module.exports = "https://www.gc-pro.gnp.com.mx/c52dad0a85a97183efa28dccd43c5fb7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/info.svg
// module id = 697
// module chunks = 0 1